module.exports = "<router-outlet></router-outlet>\r\n<div id=\"onfido-mount\"></div>\r\n<!-- <div class=\"footer\" id=\"footer\" *ngIf=\"isLoginPage==false\">{{'Common_lblFooterText' | translate}}</div> -->\r\n<!-- *ngIf=\"utilityServ.busy!=undefined && utilityServ.busy!=null\" -->\r\n<div *ngIf=\"isObj(utilityServ.busy)\">\r\n  <div *ngIf=\"isSplashscreen==false\" [ngBusy]=\"utilityServ.busy\"></div>\r\n  <div *ngIf=\"isSplashscreen==true\" [ngBusy]=\"{busy: utilityServ.busy, message: 'Sync Data...'}\"></div>\r\n</div>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main